/** Absolute application paths (for Route path, Navigate, Link). */
export const RoutePaths = {
  AUTH: '/auth',
  ONBOARDING: '/onboarding',
  TERMS: '/terms',
  PAYMENT_RESULT: '/payment/result',
  HOME: '/',
  OUTFITS: '/outfits',
  FITTING: '/fitting',
  CHAT: '/chat',
  PROFILE: '/profile',
  PROFILE_SUBSCRIPTION: '/profile/subscription',
  WARDROBE: '/wardrobe',
  CATALOG: '/catalog',
  STYLISTS: '/stylists',
  STYLIST: '/stylists/:stylistId',
} as const;

/**
 * Segments relative to parent `RoutePaths.WARDROBE` (child Route path / relative Navigate).
 */
export const WardrobeRouteSegments = {
  favorites: 'favorites',
  myItems: 'my-items',
  myItemsAdd: 'my-items/add',
  myItemsReview: 'my-items/review',
  myItemsReviewEdit: 'my-items/review/:itemId/edit',
  myItemsEdit: 'my-items/edit/:itemId',
  outfits: 'outfits',
  indexRedirect: 'my-items',
} as const;

const wardrobeBase = RoutePaths.WARDROBE;

/** Common absolute paths under `/wardrobe` (for navigation outside route definitions). */
export const WardrobePaths = {
  root: wardrobeBase,
  favorites: `${wardrobeBase}/${WardrobeRouteSegments.favorites}`,
  myItems: `${wardrobeBase}/${WardrobeRouteSegments.myItems}`,
  myItemsAdd: `${wardrobeBase}/${WardrobeRouteSegments.myItemsAdd}`,
  myItemsReview: `${wardrobeBase}/${WardrobeRouteSegments.myItemsReview}`,
  outfits: `${wardrobeBase}/${WardrobeRouteSegments.outfits}`,
} as const;

export function outfitsWithOutfitIdQuery(outfitId: string): string {
  const q = new URLSearchParams({ outfitId });
  return `${RoutePaths.OUTFITS}?${q.toString()}`;
}

export function getDefaultAuthedRoute(isOnboarded: boolean): string {
  return isOnboarded ? RoutePaths.CHAT : RoutePaths.ONBOARDING;
}
